function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1z",
  stroke: "#A0AFBE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#A0AFBE",
  strokeWidth: 1.58,
  d: "M20 10.117l2.419 2.418L9.394 25.56l-2.419-2.418z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A0AFBE",
  d: "M16 13l3.536 3.536-1.415 1.414-3.535-3.536z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 9v3m1.5-1.5h-3M22.5 17v3m1.5-1.5h-3M25.5 8v3M27 9.5h-3",
  stroke: "#A0AFBE"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26 15v1",
  stroke: "#A0AFBE",
  strokeWidth: 0.79
});
function SvgAutoAssignGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}
export default SvgAutoAssignGray;